import styles from "./PendingFirmTable.module.css";
import { Link } from "react-router-dom";
import { Button } from "@justworkshr/milo-core";
import { ThirdPartyTable } from "pages/advisor/common/components";
import { GetAllClientInvitesQuery } from "types/generated/operations";
import { useTranslation } from "react-i18next";
import { buildRelativeRemovePendingFirmLink } from "../../utils";

const { tableActionBtn, tableRow } = styles;

type Firm = NonNullable<GetAllClientInvitesQuery["allClientInvites"]>[0];

interface PendingFirmTableProps {
  firm: Firm;
}

const PendingFirmTable = ({ firm }: PendingFirmTableProps) => {
  const { t } = useTranslation();

  return (
    <ThirdPartyTable
      tableKey="pending-firms"
      tableTitle="Invited firm"
      dataCountLabel={`1 person`}
    >
      <>
        <thead>
          <tr className={tableRow}>
            <td>Name</td>
            <td>Email</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr className={tableRow} key={firm.id}>
            <td data-heap-redact-text={true}>
              {firm.firstName} {firm.lastName}
            </td>
            <td data-heap-redact-text={true}>{firm.email}</td>
            <td>
              <Button
                className={tableActionBtn}
                size="sm"
                variant="ghost"
                leftIcon="trash"
                color="destructive"
                as={Link}
                state={{ preserveScrollPosition: true }}
                to={buildRelativeRemovePendingFirmLink(firm.id)}
              >
                {t("Remove firm")}
              </Button>
            </td>
          </tr>
        </tbody>
      </>
    </ThirdPartyTable>
  );
};

export default PendingFirmTable;
